<template>
	<div>
		<v-toolbar flat class="sticky-top" color="primary" dark>
			<v-container>
				<v-row align="center">
					<v-col cols="auto">
						<v-toolbar-title> {{ $t("SmartNavBar.My_orders") }} </v-toolbar-title>
					</v-col>
					<v-spacer />
					<v-col cols="auto">
						<v-tabs background-color="transparent" v-model="tabId" @change="onTabChanged" centered
							show-arrows hide-slider class="my-auto">
							<v-tab class="text-none">{{ $t("SalesOrders.All_orders") }}</v-tab>
							<v-tab class="text-none">{{ $t("SalesOrders.Open_orders") }}</v-tab>
						</v-tabs>
					</v-col>
					<v-spacer />
					<v-col cols="auto">
						<v-text-field flat hide-details clearable outlined dense background-color="transparent"  class="my-auto"
						:placeholder="$t('Your_reference')" v-model="searchValue" append-icon="mdi-magnify"
						@keyup.native.enter="onSearch" @click:append="onSearch" @click:clear="onClear"
						style="max-width: 250px" />
					</v-col>
				</v-row>
			</v-container>
		</v-toolbar>

		<v-container>
			<v-row justify="center" v-for="order of orderList" :key="order.ordernr">
				<v-col cols="12">
					<OrderCard :order="order" />
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-btn class="my-3" v-if="this.rowIdent" :loading="loading" color="primary" @click="getOrderList()">
					{{ $t('Load_more') }}
				</v-btn>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import caas from "@/services/caas";
import OrderCard from "../components/OrderCard";
export default {
	name: "SalesOrders",
	components: { OrderCard },
	data() {
		return {
			loading: false,
			tabId: 0,
			orderList: [],
			rowsToBatch: 10,
			rowNum: 0,
			rowIdent: "",
			searchValue: "",
		};
	},
	methods: {
		getOrderList() {
			this.loading = true;
			let params = {
				statusFilter: this.tabId,
				rowNum: this.rowNum,
				rowIdent: this.rowIdent,
				rowsToBatch: this.rowsToBatch,
				search: this.searchValue,
			};
			return caas
				.rpc("getPortalUserOrders", params)
				.then((response) => {
					this.loading = false;
					if (response.data.success.data) {
						this.orderList.push(
							...response.data.success.data.orderView.order
						);
						this.rowNum = response.data.success.rowNum;
						this.rowIdent = response.data.success.rowIdent;
					} else if (response.data.success.error) {
						throw response.data.success.error;
					}
				})
				.catch((error) => {
					console.log(error.message);
					this.loading = false;
				})
		},
		onTabChanged() {
			this.orderList = [];
			this.rowNum = 0;
			this.rowIdent = "";
			this.getOrderList();
		},
		onClear() {
			this.searchValue = "";
			this.onSearch();
		},
		onSearch() {
			this.orderList = [];
			this.rowNum = 0;
			this.rowIdent = "";
			this.getOrderList();
		},
	},
	mounted() {
		this.getOrderList();
	},
};
</script>
